import { IUser } from "common/utils/UserUtils";
import { KyResponse } from "ky";
import MonarchClient from "./MonarchClient";

export interface CreateAPIKeyResponse {
	api_key: string;
	key_name: string;
}

export interface APIKeyStatusResponse {
	message: string;
}
export interface APIKeyResponse {
	name: string;
	owner_username: string;
	created_at: Date;
	active: boolean;
}

interface APIKeyOwnershipTransferRequest {
	api_key_name: string;
	new_owner_username: string;
}
interface CreateAPIKeyRequest {
	owner: string;
}

interface ImpersonateUserRequest {
	username: string;
}

class AuthClient {
	static async whoami(): Promise<IUser> {
		return MonarchClient.get("auth/whoami").then((res) => res.json());
	}

	static async changeOrg(orgId: string): Promise<void> {
		try {
			const base = window.location.origin;
			await MonarchClient.get(
				`auth/my-organization/${orgId}?redirect_success=${encodeURIComponent(
					`${base}/`
				)}&redirect_fail=${encodeURIComponent(base)}`
			);

			// Lazy import to avoid circular dependency
			const { refreshUser } = await import("common/stores/UserStore");
			refreshUser(true);
		} catch (error) {
			// Optionally log the error or handle it
			console.error("Failed to change organization:", error);
			// Do not attempt to refresh user if the GET fails
		}
	}

	static async fetchApiKeys(): Promise<APIKeyResponse[]> {
		return MonarchClient.get("auth/api-keys").then((res) => res.json());
	}

	static async createApiKey(request: CreateAPIKeyRequest): Promise<KyResponse> {
		return MonarchClient.post("auth/api-key", {
			json: request,
		});
	}

	static async deactivateApiKey(keyName: string): Promise<KyResponse> {
		return MonarchClient.put(`auth/api-key/deactivate/${keyName}`);
	}

	static async reactivateApiKey(keyName: string): Promise<KyResponse> {
		return MonarchClient.put(`auth/api-key/reactivate/${keyName}`);
	}

	static async deleteApiKey(keyName: string): Promise<KyResponse> {
		return MonarchClient.delete(`auth/api-key/${keyName}`);
	}

	static async transferApiKeyOwnership(
		transferRequest: APIKeyOwnershipTransferRequest
	): Promise<KyResponse> {
		return MonarchClient.post("auth/api-key/transfer-ownership", {
			json: transferRequest,
		});
	}

	static async impersonateUser(
		request: ImpersonateUserRequest
	): Promise<KyResponse> {
		return MonarchClient.post("auth/impersonate", {
			json: request,
		});
	}

	static async stopImpersonation(): Promise<KyResponse> {
		return MonarchClient.post("auth/stop-impersonation");
	}
}

export default AuthClient;
